import React, { forwardRef } from "react";
import { StyledInput } from "@components/form/TextField/style";
interface ITextFieldProps {
  value?: string | number;
  className?: string;
  placeholder?: string;
  name?: string;
  type?: string;
  disabled?: boolean;
  onChange?: (event: HTMLInputElement) => void;
}
const TextField = forwardRef<HTMLInputElement, ITextFieldProps>(
  ({ value, className, placeholder, name, type, disabled, onChange }, ref) => (
    <StyledInput
      type={type}
      className={className}
      ref={ref}
      value={value}
      placeholder={placeholder}
      name={name}
      disabled={disabled}
      onChange={onChange}
    />
  )
);

export default TextField;
